import {
  ComposerPrimitive,
  ThreadPrimitive,
  useComposer,
} from '@assistant-ui/react';
import {IconButton} from '@wandb/components';
import React, {type FC} from 'react';

import {useNightModeRevertFilter} from './useNightModeRevertFilter';

const ComposerAction: FC<{disableComposerSend: boolean}> = ({
  disableComposerSend,
}) => {
  const isComposerEmpty = useComposer(s => s.isEmpty);
  return (
    <div className="flex">
      <ThreadPrimitive.If running={false}>
        <ComposerPrimitive.Send asChild>
          <IconButton
            isDisabled={isComposerEmpty || disableComposerSend}
            aria-label="send message"
            variant="primary"
            icon="up"
          />
        </ComposerPrimitive.Send>
      </ThreadPrimitive.If>
      <ThreadPrimitive.If running>
        <ComposerPrimitive.Cancel asChild>
          <IconButton aria-label="cancel query" icon="stop" />
        </ComposerPrimitive.Cancel>
      </ThreadPrimitive.If>
    </div>
  );
};

export const WBAgentComposer: FC<{disableComposerSend: boolean}> = ({
  disableComposerSend,
}) => {
  const nightModeRevertFilter = useNightModeRevertFilter();

  return (
    <div className="relative">
      <div
        className="absolute inset-0 rounded bg-white dark:bg-moon-900 border dark:border-[#363C44]"
        style={{filter: nightModeRevertFilter}}
      />
      <ComposerPrimitive.Root className="relative flex flex-col gap-8 rounded border border-moon-250 bg-white p-12">
        <ComposerPrimitive.Input
          placeholder="Ask the W&B agent"
          className="w-full resize-none bg-transparent text-[15px] outline-none placeholder:text-moon-500"
          rows={1}
          autoFocus
          aria-label="Message input"
        />
        <div className="flex w-full justify-end">
          <ComposerAction disableComposerSend={disableComposerSend} />
        </div>
      </ComposerPrimitive.Root>
    </div>
  );
};
